import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const Message = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.09049 6.35666C2.55007 4.28473 4.68445 2.52903 8.11185 2.52903C11.5794 2.52903 13.6625 4.48815 13.9632 6.65849C14.1119 7.73188 13.8108 8.82675 13.0388 9.66606C12.2893 10.4808 11.138 11.0113 9.63672 11.0955L6.45902 13.3507C6.03134 13.6542 5.43935 13.3484 5.43935 12.824V11.0052C4.21521 10.7201 3.29143 10.1199 2.707 9.32604C2.06298 8.45119 1.863 7.38228 2.09049 6.35666ZM3.60378 8.66587C4.04867 9.27022 4.82846 9.78319 6.01267 9.9851C6.30465 10.0349 6.55293 10.2889 6.55293 10.6227V11.9185L9.10403 10.1081C9.21195 10.0315 9.33591 9.99366 9.45511 9.98924C10.7911 9.9397 11.6866 9.49113 12.2192 8.91218C12.7523 8.33256 12.9661 7.57595 12.8602 6.81132C12.6516 5.30562 11.1468 3.6426 8.11185 3.6426C5.05832 3.6426 3.49491 5.16744 3.17764 6.59781C3.01671 7.32334 3.15853 8.06103 3.60378 8.66587Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Message;
